import "./index.css";
import React from "react";

export const SpecialConditions = ({ individualInclusionMembers }) => {
  return (
    <div>
      {individualInclusionMembers?.map((member, _) => {
        return (
          <div
            key={member.userId}
            className="individual-inclusion-member-container"
          >
            <IndividualInclusionMembers
              name={member.userName}
              employeeId={member.userEmployeeId}
              email={member.userEmail}
            />
          </div>
        );
      })}
    </div>
  );
};

const IndividualInclusionMembers = ({ name, employeeId, email }) => {
  return (
    <div className="individual-inclusion-member">
      <div className="individual-inclusion-member-label">{name}</div>
      <div className="individual-inclusion-member-value">({employeeId})</div>
    </div>
  );
};
